import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import dayjs from "dayjs";
import Layout from "../../components/layout/Layout";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Grid,
  makeStyles,
} from "@material-ui/core";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useEffect, useState } from "react";
import useTable from "../../components/customHelpers/usePaginationTable";
import Notify from "../../components/customHelpers/Notify";
import Store from "../../actions/store";
import Category from "../../actions/Catagory";
import SearchIcon from "@mui/icons-material/Search";
import Product from "../../actions/product";
import Admin from "../../components/auth/Admin";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableHead,
  TextField,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Notification from "../../components/customHelpers/Notification";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { formatNumber, getTimestamp } from "../../utils/utils";
import ClearIcon from "@mui/icons-material/Clear";
const initialHeadCells = [
  { id: "name", label: "Product Name", isVisible: true },
  { id: "sku", label: "Sku", isVisible: true },
  { id: "category", label: "Category", isVisible: true },
  { id: "store", label: "Store", isVisible: true },
  { id: "price", label: "Price", isVisible: true },
  { id: "quantity", label: "Quantity", isVisible: true },
  { id: "totalPrice", label: "Total Price", isVisible: true },
  { id: "createdAt", label: "CreatedAt", isVisible: true },
];

const useStyles = makeStyles((theme) => ({
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  pageSizeSelect: {
    minWidth: 120,
    marginRight: theme.spacing(2),
  },
}));
const InventoryReport = () => {
  const classes = useStyles();
  const [headCells, setHeadCells] = useState(initialHeadCells);
  const hiddenColumns = headCells.filter((cell) => !cell.isVisible);
  const { viewAllCatagories } = Category();
  const [categories, setCategories] = useState([]);

  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllStores } = Store();
  const { viewAllProductsListsWithPages, viewTotalPriceProductsLists } =
    Product();
  const [productLists, setProductLists] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelecetedCategory] = useState("");
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelecetedStore] = useState("");
  const [page, setPage] = useState(1);
  const [totalPrice, setTotalPrice] = useState({
    totalPrice: 0,
    isClick: true,
  });

  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const pageSizes = [15, 25, 50, 100];
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getProductData();
  }, [
    page,
    limit,
    searchQuery,
    selectedCategory,
    selectedStore,
    startDate,
    endDate,
  ]);
  useEffect(() => {
    getAllStores();
    getAllCategories();
    getTotalPrice();
  }, []);
  useEffect(() => {
    getTotalPrice();
  }, [selectedCategory, selectedStore, startDate, endDate]);
  const getTotalPrice = () => {
    viewTotalPriceProductsLists(
      selectedCategory,
      selectedStore,
      startDate,
      endDate
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.totalPrice) {
        setTotalPrice({
          totalPrice: data.totalPrice || 0,
          isClick: true,
        });
      }
    });
  };
  const getAllStores = () => {
    setValues({ ...values, loading: true });
    viewAllStores().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.stores) {
        setValues({
          ...values,
          loading: false,
        });
        setStores(data.stores);
      }
    });
  };
  const getProductData = () => {
    viewAllProductsListsWithPages(
      page,
      limit,
      searchQuery,
      selectedCategory,
      selectedStore,
      startDate,
      endDate
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.product) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.product);
        setProducts(data.product);
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };
  const getAllCategories = () => {
    setValues({ ...values, loading: true });
    viewAllCatagories().then((data) => {
      if (data.err) {
        setValues({
          ...values,
          loading: false,
        });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.categorys) {
        setValues({
          ...values,
          loading: false,
        });
        setCategories(data.categorys);
      }
    });
  };

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(productLists, initialHeadCells, filterFn);
  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setPage(1);
    setTotalPrice({ ...totalPrice, isClick: true });
    setSelecetedCategory(category);
  };
  const handleStoreChange = (e) => {
    const store = e.target.value;
    setPage(1);
    setTotalPrice({ ...totalPrice, isClick: true });
    setSelecetedStore(store);
  };

  const handleStartDateChange = (newValue) => {
    setPage(1);
    setStartDate(newValue);
    setTotalPrice({ ...totalPrice, isClick: true });
  };

  const handleEndDateChange = (newValue) => {
    setPage(1);
    setEndDate(newValue);
    setTotalPrice({ ...totalPrice, isClick: true });
  };
  const generateReportFilename = (
    startDate,
    endDate,
    category,
    storeName,
    timestamp
  ) => {
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "AllDates";
    const formattedEndDate = endDate ? dayjs(endDate).format("YYYY-MM-DD") : "";
    const formattedCategory = category || "AllCategories";
    const formattedStore = storeName || "AllStores";

    return `${formattedStartDate}_${formattedEndDate}_${formattedCategory}_${formattedStore}_Inventory-report_${timestamp}`;
  };
  const exportToExcel = () => {
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const dataToExport = productLists.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "name":
            return item.product?.name;
          case "sku":
            return item.product?.sku;
          case "category":
            return item.product?.category;
          case "store":
            return item.store?.locationName;
          case "price":
            return item.price;
          case "quantity":
            return item.quantity;
          case "totalPrice":
            return item.price * item.quantity;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );

    const totalPriceSum = productLists.reduce((sum, item) => {
      return sum + item.price * item.quantity;
    }, 0);
    dataToExport.push([
      "Total Price",
      totalPriceSum.toFixed(2),
      "",
      "",
      "",
      "",
      "",
      "",
    ]);
    const worksheet = XLSX.utils.aoa_to_sheet([
      filteredHeadCells.map((cell) => cell.label),
      ...dataToExport,
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const timestamp = getTimestamp();
    const filename = generateReportFilename(
      startDate,
      endDate,
      selectedCategory,
      selectedStore,
      timestamp
    );

    saveAs(blob, `${filename}.xlsx`);

    handleClose();
  };
  const exportToPDF = () => {
    const doc = new jsPDF();
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);

    const totalPriceSum = productLists.reduce((sum, item) => {
      return sum + item.price * item.quantity;
    }, 0);

    const bodyData = productLists.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "name":
            return item.product?.name;
          case "sku":
            return item.product?.sku;
          case "store":
            return item.store?.locationName;
          case "category":
            return item.product?.category;
          case "price":
            return item.price;
          case "quantity":
            return item.quantity;
          case "totalPrice":
            return item.price * item.quantity;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );
    doc.autoTable({
      head: [filteredHeadCells.map((cell) => cell.label)],
      body: bodyData,
      styles: {
        fontSize: 10,
      },
      headStyles: {
        fillColor: [244, 151, 3],
        textColor: [20, 61, 89],
      },
    });

    const finalY = doc.lastAutoTable.finalY || 10;
    doc.text(
      `Total Price: ${totalPriceSum.toFixed(2)}`,
      doc.internal.pageSize.getWidth() - 20,
      finalY + 10,
      { align: "right" }
    );

    const timestamp = getTimestamp();
    const filename = generateReportFilename(
      startDate,
      endDate,
      selectedCategory,
      selectedStore,
      timestamp
    );
    doc.save(`${filename}.pdf`);
    handleClose();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const visibleColumns = headCells.filter((cell) => cell.isVisible);

  const handleColumnToggle = (id) => {
    const updatedHeadCells = headCells.map((cell) =>
      cell.id === id ? { ...cell, isVisible: !cell.isVisible } : cell
    );
    setHeadCells(updatedHeadCells);
  };
  const clearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setProductLists(products);
    setSelecetedCategory("");
    setSelecetedStore("");
    setTotalPrice({ ...totalPrice, isClick: true });
    setPage(1);
    setLimit(15);
  };

  const handlePageChange = (event, newPage) => {
    setTotalPrice({ ...totalPrice, isClick: true });
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Inventory Report
          </Typography>
          <Box display="flex" justifyContent="center" gap={2} m={1} p={1}>
            <Box sx={{ width: "20%" }} mb={-10}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Start Date"
                    value={startDate}
                    sx={{ width: "100%" }}
                    onChange={handleStartDateChange}
                    format="DD-MM-YYYY"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box sx={{ width: "20%" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={handleEndDateChange}
                    sx={{ width: "100%" }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>

            <TextField
              id="outlined-select-category"
              select
              label="Filter By Category"
              sx={{ marginTop: "8px", width: "90%" }}
              value={selectedCategory}
              onChange={handleCategoryChange}
            >
              {categories.map((option) => (
                <MenuItem key={option} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="outlined-select-store"
              select
              label="Filter By Store"
              sx={{ marginTop: "8px", width: "80%" }}
              value={selectedStore}
              onChange={handleStoreChange}
            >
              {stores.map((option) => (
                <MenuItem key={option} value={option.locationName}>
                  {option.locationName}
                </MenuItem>
              ))}
            </TextField>

            <Box display="flex" justifyContent="end" gap={1} m={1}>
              <Box>
                <Button
                  variant="contained"
                  onClick={clearFilters}
                  endIcon={<CancelIcon />}
                  sx={{
                    padding: "6px 12px",
                    fontSize: "0.875rem",
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)",
                    },
                  }}
                >
                  Clear
                </Button>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  id="demo-positioned-button"
                  aria-controls={open ? "demo-positioned-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  startIcon={<DownloadIcon />}
                  sx={{
                    padding: "6px 12px", // Decreased padding for smaller button
                    fontSize: "0.875rem", // Smaller font size
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)",
                    },
                  }}
                >
                  Export
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <MenuItem onClick={exportToPDF}>PDF</MenuItem>
                  <MenuItem onClick={exportToExcel}>Excel</MenuItem>
                </Menu>
              </Box>
            </Box>
          </Box>{" "}
          <Grid container spacing={2}>
            <Grid
              item
              xs={hiddenColumns.length > 0 ? 10 : 12}
              className="card__body"
            >
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {visibleColumns.map((headCell) => (
                            <TableCell
                              className={
                                headCell.isVisible
                                  ? "table-cell-visible"
                                  : "table-cell-hidden"
                              }
                              key={headCell.id}
                              style={{
                                backgroundColor: "rgba(244,151,3,.8)",
                                color: "rgb(20,61,89)",
                                width: headCell.isVisible ? "auto" : "0",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1, // Adjust the gap between Typography and Checkbox
                                }}
                              >
                                <Typography variant="subtitle1" noWrap>
                                  {headCell.label}
                                </Typography>
                                <Checkbox
                                  checked={headCell.isVisible}
                                  onChange={() =>
                                    handleColumnToggle(headCell.id)
                                  }
                                  icon={<CheckBoxOutlineBlankIcon />}
                                  checkedIcon={<CancelIcon />}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      backgroundColor: "transparent !important", // Remove background color from Checkbox icon
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {recordsAfterSortingAndFiltering().length > 0 ? (
                          recordsAfterSortingAndFiltering().map((item) => (
                            <TableRow key={item.id}>
                              {visibleColumns.map((headCell) => (
                                <TableCell key={headCell.id}>
                                  {headCell.id === "name"
                                    ? item.product?.name
                                    : headCell.id === "sku"
                                    ? item.product?.sku
                                    : headCell.id === "category"
                                    ? item.product?.category
                                    : headCell.id === "store"
                                    ? item.store?.locationName
                                    : headCell.id === "price"
                                    ? item.price
                                    : headCell.id === "quantity"
                                    ? item.quantity
                                    : headCell.id === "totalPrice"
                                    ? item.price * item.quantity
                                    : headCell.id === "createdAt"
                                    ? new Date(item.createdAt).toLocaleString()
                                    : null}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        ) : (
                          <Norecords col={6} />
                        )}
                      </TableBody>
                    </Table>
                  </TblContainer>
                  <Box className={classes.paginationContainer}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" style={{ marginRight: 8 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        className={classes.pageSizeSelect}
                        size="small"
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {productLists.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                      />
                    )}
                  </Box>{" "}
                  <Box display="flex" justifyContent="end" gap={2} m={1} p={1}>
                    <div
                      style={{
                        marginRight: "35px",
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      Total Price:{" "}
                      {totalPrice.isClick
                        ? formatNumber(totalPrice.totalPrice)
                        : formatNumber(
                            productLists.reduce((sum, item) => {
                              return sum + item.price * item.quantity;
                            }, 0)
                          )}
                    </div>
                  </Box>
                </Paper>
              )}
            </Grid>
            {hiddenColumns.length > 0 && (
              <Grid item xs={2} className="card__body" sx={{ marginLeft: 10 }}>
                <Typography variant="h6">Hidden Columns</Typography>
                <FormGroup sx={{ marginTop: 0 }}>
                  {hiddenColumns.map((headCell, index) => (
                    <FormControlLabel
                      key={headCell.id}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              backgroundColor: "transparent",
                            },
                          }}
                          onChange={() => handleColumnToggle(headCell.id)}
                        />
                      }
                      label={headCell.label}
                      sx={{
                        marginBottom:
                          index === hiddenColumns.length - 1 ? 0 : 1,
                        "& .MuiFormControlLabel-label": {
                          marginTop: 0,
                        },
                      }}
                    />
                  ))}
                </FormGroup>
              </Grid>
            )}
            <Notification notify={notify} setNotify={setNotify} />
          </Grid>
        </div>
      </Admin>
    </Layout>
  );
};

export default InventoryReport;
